import Container from './DeviationMergeNotification.container';
import DeviationMergeNotification from './DeviationMergeNotification';

export default Container(DeviationMergeNotification);
